export default __webpack_public_path__ + "static/media/Vazir.9b82bf46.woff";